import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { BodegaService } from 'src/app/services/bodega.service';
import { ClienteProveedorService } from 'src/app/services/cliente-proveedor.service';
import { CondicionPagoService } from 'src/app/services/condicion-pago.service';
import { DocumentoRecepcionadoDetalleService } from 'src/app/services/documento-recepcionado-detalle.service';
import { DocumentoRecepcionadoService } from 'src/app/services/documento-recepcionado.service';
import { DocumentoService } from 'src/app/services/documento.service';
import { ImpuestosService } from 'src/app/services/impuestos.service';
import { ListaPrecioDetalleService } from 'src/app/services/lista-precio-detalle.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoDTEService } from 'src/app/services/tipo-dte.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProveedorComponent } from 'src/app/views/shared/modal-seleccionar-proveedor/modal-seleccionar-proveedor.component';
import { ModalSeleccionarProductoProveedorComponent } from '../../docs-recibidos-manualmente/modal-seleccionar-producto/modal-seleccionar-producto/modal-seleccionar-producto-proveedor.component';
import { ModalSeleccionDocumentoComponent } from '../modal-seleccion-documento/modal-seleccion-documento.component';
// import { ModalObservacionesComponent } from '../modal-observaciones/modal-observaciones.component';
import { MotivoDevolucionService } from '../../../../services/motivo-devolucion.service';

@Component({
  selector: 'app-modal-agregar-documento-nota-credito',
  templateUrl: './modal-agregar-documento-nota-credito.component.html',
  styleUrls: ['./modal-agregar-documento-nota-credito.component.scss'],
  providers: [SecurityService],
})
export class ModalAgregarDocumentoNotaCreditoComponent implements OnInit {
  // Modales
  @ViewChild(ModalSeleccionDocumentoComponent, { static: true }) modalSeleccionarDocumento: ModalSeleccionDocumentoComponent;
  @ViewChild(ModalSeleccionarProductoProveedorComponent, { static: true }) modalSeleccionarProduct: ModalSeleccionarProductoProveedorComponent;
  @ViewChild(ModalSeleccionarProveedorComponent, { static: true }) modalSeleccionarProveedor: ModalSeleccionarProveedorComponent;
  // @ViewChild(ModalObservacionesComponent, { static: true }) modalObservaciones: ModalObservacionesComponent
  @ViewChild('agregarDoc', { static: true })
  agregarDocModal: ModalDirective;

  @Output() onProveedorChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() onExecuteBuscar: EventEmitter<any> = new EventEmitter<any>();

  // check descuento
  readonly RB_TIPO_PORCENTAJE_DESC: boolean = true;
  readonly RB_TIPO_PESO_DESC: boolean = false;

  // check recargo
  readonly RB_TIPO_PORCENTAJE_REC: boolean = true;
  readonly RB_TIPO_PESO_REC: boolean = false;

  // Constantes
  readonly PRODUCTO_LIBRE_AFECTO: String = '_PRODUCTO_LIBRE_AFECTO';
  readonly PRODUCTO_LIBRE_EXCENTO: String = '_PRODUCTO_LIBRE_EXCENTO';

  productoSeleccionado: any = null;

  // Form
  formHeader: FormGroup;
  formImpuestos: FormGroup;
  formItems: FormGroup;
  formMotivoGeneral: FormGroup;

  // Data & tmp
  public rutEmpresa: number;
  public sucursalCodigo: number;
  public rut_usuario: number;

  headerData: any = {};

  // Utils
  private log: any;

  impuesto: string = '';
  Montoimpuesto: any;
  nombreImpuesto: string = '';

  HiddeIvaUseComun = false;

  checkAll: boolean = false;
  checkAllDetalle: boolean = false;
  checkDetail: boolean = false;
  countSelectImp: number = 0;
  countSelectDetalle: number = 0;
  montoTotal: number = 0; //D
  montoImpuestoAdicional: number = 0;
  proveedorSeleccionado: any = null;
  //TOTAL CABECERA
  SubTotal: number = 0;
  DescGbl: number = 0;
  RecargoGbl: number = 0;
  MontoAf: number = 0; //A
  MontoEx: number = 0; //B
  MontoIva: number = 0; //C
  IvaRec: number = 0;
  IvaNoRec: number = 0;
  IvaActF: number = 0;
  IvaRet: number = 0;
  IvaComn: number = 0;
  TotalBruto: number = 0;
  seleccionaRutProveedor: any;
  priceU: number;
  amountInput: number;
  inputDiscount: number;
  inputSurcharge: number;
  taxInput: number;
  totalLine: number = 0;
  showFactor: boolean = false;
  showBodega: boolean = true;
  EnableDoc: boolean = false;
  currentSearchParams: any;
  listaDetalleDoc: any;
  showImpuesto: boolean = false;

  paginationContext: PaginationContext = new PaginationContext();
  arrayGetItems: Array<any> = [];
  loading: boolean = false;
  AddlistaDetalleDocRec: Array<any> = [];
  totalMonto: number = 0;
  detalleNombreItem: any;
  EnableButton: boolean = false;
  folio: number = 0;
  Existefolio: string = '';

  initialValues: any;
  detalleItem: any;

  optionsDoctoReferencia: Array<any> = [];
  dataCabecera: any = null;
  datoDetalle: any = null;
  additionalHeaderInfo: any = null;
  detalleCantidad = 0;

  observaciones: string = '';
  subTotal: number = 0;
  Descto: number = 0;
  Recargo: number = 0;
  Total: number = 0;
  dataDetalle: any = null;
  totalMontosinSKU: number = 0;
  subTotalsinSKU: number = 0;
  DesctosinSKU: number = 0;
  RecargosinSKU: number = 0;
  TotalsinSKU: number = 0;
  disabledTotales: boolean = true;
  listaVaciaDetalle: Array<any> = [];

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private impuestosService: ImpuestosService,
    private condicionPagoService: CondicionPagoService,
    private tipodteService: TipoDTEService,
    private rutService: RutService,
    private documentoService: DocumentoService,
    private documentoRecepcionadoService: DocumentoRecepcionadoService,
    private documentoRecepcionadoDetalleService: DocumentoRecepcionadoDetalleService,
    private messageRendererService: MessageRendererService,
    private datesService: DatesService,
    private bodegaService: BodegaService,
    private clienteProveedorService: ClienteProveedorService,
    private tipoDTEService: TipoDTEService,
    private listaPrecioDetalleService: ListaPrecioDetalleService,
    private motivoDevolucionService: MotivoDevolucionService
  ) {
    this.log = this.clog.log('DOC-RECIBIDO-MANUAL-MODAL-AGREGAR-DETALLE');
  }

  optionsMonth: any[] = [];
  optionsYear: any[] = [];
  optionsCondPago: Array<any> = [];
  optionsTipoFact: Array<any> = [];
  optionsTipoItem: Array<any> = [];
  optionsUndMed: Array<any> = [];
  optionsSelect: Array<any> = [];
  optionsImp: Array<any> = [];
  optionsCategoria: Array<any> = [];
  optionsFamilia: Array<any> = [];
  optionsBodega: Array<any> = [];
  optionsFormatoProductoLibre: Array<any> = [{ value: 'UNID', label: 'Unidad' }];
  optionsMotivoGeneral: Array<any> = [];

  //variable for table
  dynamicArray: Array<any> = [];

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rut_usuario = this.accesolocalstorage.getRutUsuario();

    this.loadMesesAndAnhos();
    this.createFormInitialValues();
    this.createForm();
    this.loadBodegas();
    this.loadImpuestosAdic();
    // this.loadCondicionPago();
    this.loadTipoFactura();
    this.loadTipoItem();
    this.loadComboDoctoRef();
    this.loadMotivoDevolucionGeneral();
    this.formChangesSubscriptions();
  }

  private loadComboDoctoRef() {
    // Tipos documentos
    this.tipoDTEService.GetByTipoDte(1, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsDoctoReferencia = registros.map((tipo) => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }));
      this.setDefaultDoctoReferencia();
    });

    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('doctoReferencia'), this.optionsDoctoReferencia);
  }

  loadTipoItem() {
    this.optionsTipoItem = [
      { value: 2, label: 'Parcial' },
      { value: 4, label: 'Corrección de monto ' },
    ];

    this.formValidatorsService.selectFirstOrDefault(this.formItems.get('productoExistente.tipoItems'), this.optionsTipoItem);
  }

  private loadMotivoDevolucionGeneral() {
    // Tipos documentos
    this.motivoDevolucionService.GetMotivoDevolucionGeneral(this.rutEmpresa, this.sucursalCodigo, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsMotivoGeneral = registros.map((tipo) => ({ value: tipo.codigo, label: tipo.nombre, ...tipo }));
    });
  }

  loadBodegas() {
    this.changeShowInventario()
    const inputParams = {
      rut_empresa: this.rutEmpresa,
      sucursal_codigo: this.sucursalCodigo,
    };

    this.bodegaService.ObtenerBodegas(inputParams, ({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsBodega = registros.map((bodega) => ({
        value: bodega.codigo,
        label: bodega.nombre,
        ...bodega,
      }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('bodega'), this.optionsBodega);
    });
  }

  setDefaultDoctoReferencia() {
    const facturaOption = this.optionsDoctoReferencia.filter((p) => p.codigo === 33);
    if (facturaOption && facturaOption.length > 0) this.formHeader.get('doctoReferencia').setValue(facturaOption[0].codigo);
  }

  createFormInitialValues() {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;
    this.initialValues = {
      mesPeriodo: currentMonth,
      gestion: currentYear,
    };
  }

  /********* FORM *********/
  private createForm() {
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formHeader = this.fb.group({
      // buscarPor: [this.TIPO_NOMBRE, [Validators.required]],
      // nombre_rut: ['', [Validators.required]]
      doctoReferencia: [null, [Validators.required, Validators.min(1)]],
      nroDoc: [null],
      // CondPago:[''],
      tipoFact: [''],
      rutProveedor: [null, [Validators.required]],
      mesPeriodo: [this.initialValues.mesPeriodo, [Validators.required]],
      gestion: [this.initialValues.gestion, [Validators.required]],
      nFolio: [null, [Validators.required]],
      GlosaN: [''],
      FechaDoc: [currentDate],
      FechaVenc: [currentDate],
      IvaUsoComun: [false],
      EntregaGratuita: [false],
      MontoBrutoDetalle: [false],
      MueveInventario:[true],
      FactorIva: [0],
      bodega: [''],
    });

    this.formImpuestos = this.fb.group({
      impAdic: [null],
    });

    this.formItems = this.fb.group({
      esProductoLibre: [false],
      productoLibre: this.fb.group({
        codigo: ['', [Validators.required, Validators.min(1)]],
        descripcion: ['', [Validators.required]],
        cantidad: [null, [Validators.required, Validators.min(1)]],
        formato: ['UNID', [Validators.required]],
        precioUnitario: [0, [Validators.required, Validators.min(1)]],
        es_exento: [this.PRODUCTO_LIBRE_AFECTO, [Validators.required]],
      }),
      productoExistente: this.fb.group({
        tipoItems: [2],
        codProduct: [null, [Validators.required]],
        formatCode: [null, [Validators.required]],
        impAdic: [null],
        ActivoFijo: [false],
        tipoDesc: [this.RB_TIPO_PORCENTAJE_DESC, [Validators.required]],
        tipoRec: [this.RB_TIPO_PORCENTAJE_REC, [Validators.required]],
        AsigImpuesto: [false, [Validators.required]],
        codCantidad: [null],
        codPrecioU: [null],
        codDescuento: [null],
        codRecargo: [null],
      }),
    });

    this.formMotivoGeneral = this.fb.group({
      motivo: [null, [Validators.required]],
    });
    this.formItems.get('productoLibre.codigo').disable();
  }

  formChangesSubscriptions() {
    this.formMotivoGeneral.get('motivo').valueChanges.subscribe((p) => {
      if (this.dataCabecera != null) {
        if (this.dataCabecera.detalleDocumento != null) {
          this.dataCabecera.detalleDocumento.forEach((mov) => {
            if (mov.additionalInfo.checked) mov.motivo_devolucion_especifico_codigo = p;
          });
          this.onDocumentoSeleccionado(this.dataCabecera);
          this.log('motivoEspecificoChange', this.dataCabecera.detalleDocumento);
        }
      }
    });

    this.formHeader
      .get('rutProveedor')
      .valueChanges.pipe(filter(Boolean), debounceTime(2500))
      .subscribe((rut: string) => {
        this.modalSeleccionarProveedor.searchByRut(rut);
        this.EnableItemAndSave();
      });

    this.formItems
      .get('productoExistente.codProduct')
      .valueChanges.pipe(filter(Boolean), debounceTime(2500))
      .subscribe((codProduct: string) => {
        this.modalSeleccionarProduct.searchByCodeProduct(codProduct);
      });

    this.formHeader
      .get('nFolio')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((folio: number) => {
        this.folio = folio;
        this.EnableItemAndSave();
      });

    this.formImpuestos.get('impAdic').valueChanges.subscribe((TipoImp: Number) => {
      if (TipoImp) {
        this.impuesto = this.optionsSelect.filter((p) => p.value === TipoImp)[0].codigo;
        this.Montoimpuesto = this.optionsSelect.filter((p) => p.value === TipoImp)[0].valor;
        this.nombreImpuesto = this.optionsSelect.filter((p) => p.value === TipoImp)[0].nombre;
      }
    });

    this.formHeader
      .get('nroDoc')
      .valueChanges.pipe(filter(Boolean), debounceTime(1000))
      .subscribe((nroDoc: string) => {
        if (!nroDoc) return;
        this.searchByNroDoc();
      });

    this.formItems.get('productoExistente.tipoItems').valueChanges.subscribe((tipoItem: number) => {
      if (tipoItem === 4) {
        //CORRECCION MONTO
        this.formItems.get('esProductoLibre').setValue(true);
      } else {
        //PARCIAL
        this.formItems.get('esProductoLibre').setValue(false);
      }
    });
  }

  get doctoReferencia() {
    if (this.formHeader && this.formHeader.get('doctoReferencia')) return this.formHeader.get('doctoReferencia').value;
    return 0;
  }

  searchByNroDoc() {
    const folio = Number(this.formHeader.get('nroDoc').value);
    const tipo_dte_codigo = this.formHeader.get('doctoReferencia').value ? this.formHeader.get('doctoReferencia').value : 0;
    if (folio) {
      const proveedorRut = this.formHeader.get('rutProveedor').value;
      this.modalSeleccionarDocumento.searchByNroDoc(Number(folio), Number(tipo_dte_codigo), proveedorRut); // this.formHeader.get("doctoReferencia").value)
    }
  }

  loadMesesAndAnhos() {
    this.optionsMonth = this.datesService.GetMonths();
    this.optionsYear = this.datesService.GetRangeYears();
  }

  private loadImpuestosAdic() {
    this.impuestosService.obtenerImpuestos(({ respuesta }) => {
      const { registros } = respuesta;

      this.optionsSelect = registros.map((imp) => ({
        value: imp.codigo,
        label: imp.nombre,
        ...imp,
      }));
      // this.formValidatorsService.selectFirstOrDefault(this.formImpuestos.get('impAdic'), this.optionsSelect)
    });
  }

  loadTipoFactura() {
    this.tipodteService.obtenerTipoCompraRecepcionDoc(({ respuesta }) => {
      const { registros } = respuesta;
      this.optionsTipoFact = registros.map((fact) => ({
        value: fact.codigo,
        label: fact.nombre,
        ...fact,
      }));
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('tipoFact'), this.optionsTipoFact);
    });
  }

  show() {
    this.agregarDocModal.show();
  }

  OpenSelectProduct() {
    this.modalSeleccionarProduct.show();
  }

  onDocumentoSeleccionado({ data }) {
    if (data) {
      this.loading = true;
    } else {
      this.loading = true;
    }

    if (data != undefined) {
      this.dataCabecera = this.cleanDataCabecera(data); //.cabecera

      this.dataCabecera.cabecera.additionalInfo = {};
      this.dataCabecera.cabecera.additionalInfo.cliente_proveedor_rut_completo = this.rutService.AgregarDV(this.dataCabecera.cabecera.rut_emisor);
      this.formHeader.get('nroDoc').setValue(data.cabecera.folio);

      this.dataCabecera.detalleDocumento.forEach((mov, index) => {
        mov.additionalInfo = {};
        mov.additionalInfo.index = index;
        mov.additionalInfo.checked = false;
        mov.additionalInfo.Newcantidad = 0;
      });

      if (!this.dataCabecera) {
        this.additionalHeaderInfo = null;
        return;
      }

      this.additionalHeaderInfo = data.cabecera.additionalInfo;
      const detalle = this.dataCabecera.detalleDocumento;
      this.subTotal = _.sumBy(detalle, 'precio_neto');
      this.Descto = _.sumBy(detalle, 'monto_descuento');
      this.Recargo = _.sumBy(detalle, 'monto_recargo');
      this.Total = _.sumBy(detalle, 'monto_total');
      this.disabledTotales = true;
    }
  }

  onNotFoundDocumento(data) {
    console.log(data);
    this.dataCabecera = null;
    this.SubTotal = 0;
    this.MontoAf = 0;
    this.MontoEx = 0;
    this.DescGbl = 0;
    this.RecargoGbl = 0;
  }

  private cleanDataCabecera(_dataCabecera) {
    if (_dataCabecera != undefined) {
      delete _dataCabecera.cabecera.cliente_proveedor_rut_completo;

      delete _dataCabecera.cabecera.__typename;

      _dataCabecera.detalleDocumento.map((p) => {
        delete p.__typename;

        // parche para que tome la validación en el detalle
        if (p.motivo_devolucion_especifico_codigo === 0) p.motivo_devolucion_especifico_codigo = null;

        if (p.atributos) {
          p.atributos.map((attr) => {
            delete attr.__typename;
          });
        }
      });
      return _dataCabecera;
    }
  }

  changeProveedorRut(proveedorRut) {
    if (proveedorRut != null && proveedorRut != '') {
      this.EnableDoc = true;
    } else {
      this.EnableDoc = false;
      this.proveedorSeleccionado = null;
      this.formHeader.get('nroDoc').setValue(null);
    }
  }

  changeShowFactor() {
    if (this.formHeader.get('IvaUsoComun').value === true) {
      this.showFactor = true;
    } else {
      this.showFactor = false;
    }
  }

  changeShowInventario(){
    if(this.formHeader.get('MueveInventario').value === true){
      this.showBodega = true;
    }else{
      this.showBodega = false;
    }
  }

  OnAddImpuestoAd() {
    const params = {
      codigo: this.impuesto,
      detalle: this.nombreImpuesto,
      valor: this.Montoimpuesto,
      index: this.impuesto,
      checked: false,
    };

    this.dynamicArray.push(params);
    const PorcentajeImpuestoAdic = _.sumBy(this.dynamicArray, 'valor') / 100;
    this.montoImpuestoAdicional = this.MontoAf * PorcentajeImpuestoAdic;
    console.log(this.MontoIva, this.MontoAf, this.MontoEx, this.montoTotal);

    //OBTENER MONTO TOTAL
    this.montoTotal = _.sumBy(this.dynamicArray, 'valor');
    this.TotalBruto = this.MontoIva + this.MontoAf + this.MontoEx + this.montoImpuestoAdicional;
  }

  checkAllChange({ checked }) {
    this.dynamicArray.forEach((detalle) => {
      detalle.checked = checked;
    });
    //SELECCIONAR TODO
    this.checkAll = checked;

    //ELEMENTOS SELECCIONADOS
    this.countSelectImp = this.dynamicArray.filter((x) => x.checked === true).length;
  }

  checkDetalle({ index }, { checked }) {
    this.dynamicArray.map((detalle) => {
      if (detalle.codigo === index) {
        detalle.checked = checked;
      }
    });

    //DESELECCIONAR EL CAMPO SELECT ALL
    const totalUnselected: number = this.dynamicArray.filter((detalle: any) => !detalle.checked).length;
    this.checkAll = totalUnselected === 0;

    //SUMA DE ELEMENTOS SELECCIONADOS
    this.countSelectImp = this.dynamicArray.filter((x) => x.checked === true).length;
  }

  OnDeleteDetail() {
    var atleastOneSelected = this.dynamicArray.filter((checkbox) => checkbox.checked === true);

    if (atleastOneSelected.length === 0) {
      this.countSelectImp = 0;
      this.toastService.error('No existen registros para eliminar');
      return;
    }

    var UnSelectData = this.dynamicArray.filter((checkbox) => checkbox.checked === false);
    this.dynamicArray = UnSelectData;

    if (this.checkAll === true) {
      this.countSelectImp = 0;
    }

    this.checkAll = false;
    //SUMA DE ELEMENTOS NO SELECCIONADOS
    this.montoTotal = _.sumBy(this.dynamicArray, 'valor');
    const PorcentajeImpuestoAdic = _.sumBy(this.dynamicArray, 'valor') / 100;
    this.montoImpuestoAdicional = this.MontoAf * PorcentajeImpuestoAdic;
    this.TotalBruto = this.MontoIva + this.MontoAf + this.MontoEx + this.montoImpuestoAdicional;
  }

  OnChangeTotalxIva(iva) {
    this.MontoIva = parseInt(iva);

    if (iva === '') {
      this.MontoIva = 0;
    }

    if (!this.MontoAf) {
      this.MontoAf = 0;
    }
    if (!this.MontoEx) {
      this.MontoEx = 0;
    }

    this.TotalBruto = this.MontoIva + this.MontoAf + this.MontoEx + this.montoImpuestoAdicional;
  }

  OnChangeTotalxAfecto(afecto) {
    this.MontoAf = parseInt(afecto);

    if (afecto === '') {
      this.MontoAf = 0;
    }

    if (!this.MontoIva) {
      this.MontoIva = 0;
    }
    if (!this.MontoEx) {
      this.MontoEx = 0;
    }

    this.fetchMontoIVA(this.MontoAf);
  }

  OnChangeTotalxExento(exento) {
    this.MontoEx = parseInt(exento);

    if (exento === '') {
      this.MontoEx = 0;
    }

    if (!this.MontoIva) {
      this.MontoIva = 0;
    }
    if (!this.MontoAf) {
      this.MontoAf = 0;
    }

    this.TotalBruto = this.MontoIva + this.MontoAf + this.MontoEx + this.montoImpuestoAdicional;
  }

  onProductSeleccionado(data) {
    this.productoSeleccionado = data;
    this.formItems.get('productoExistente.codProduct').setValue(this.productoSeleccionado.producto_proveedor);
    this.formItems.get('productoExistente.formatCode').setValue(this.productoSeleccionado.formato_codigo);
    this.fetchPrecioCosto(data);
  }

  timeout = null;

  recibirDatosdelnroDoc(nrdoc) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.onSearchChange(nrdoc);
    }, 2000);
  }

  onSearchChange(folio) {
    console.log('hola');
    const tipo_dte_codigo = this.formHeader.get('doctoReferencia').value ? this.formHeader.get('doctoReferencia').value : 0;
    const proveedorRut = this.formHeader.get('rutProveedor').value;
    this.modalSeleccionarDocumento.searchByNroDoc(Number(folio), Number(tipo_dte_codigo), proveedorRut);
  }

  // VALIDACION CAMPOS EN FALSO
  OnChangeFolio(folio) {
    if (folio == 0) {
      this.EnableButton = false;
    }

    if (folio == '') {
      this.EnableButton = false;
    }

    if (folio == null) {
      this.EnableButton = false;
    }

    this.Existefolio = folio;
  }

  searchByFolio(Folio: number, tipodteCodigo: number, proveedor: number) {
    let lastFolio: number = 0;

    // Query Local
    if (this.Existefolio == '' || this.Existefolio == null) {
      this.EnableButton = false;
    } else {
      if (lastFolio !== Folio) {
        lastFolio = Folio;

        const inputParams = {
          entidad: {
            rut_receptor: this.rutEmpresa,
            sucursal_codigo: this.sucursalCodigo,
            rut_emisor: this.rutService.QuitarDV(proveedor),
            tipo_dte_codigo: tipodteCodigo,
            folio: lastFolio,
          },
        };

        this.documentoRecepcionadoService.existeFolio(inputParams, ({ mensajes, respuesta }) => {
          const ok = respuesta !== null;
          if (!ok) {
            this.messageRendererService.showErrors(mensajes);
            this.loading = false;
            return;
          }

          if (respuesta === true) {
            this.messageRendererService.showInfoMessages(mensajes);
            return;
          }

          // Retorna false, se puede usar
          if (respuesta === false) {
            this.EnableButton = true;
          }
        });
      }
    }
  }

  OnChangeRutProveedor(rutproveedor) {
    this.formHeader.get('rutProveedor').setValue(rutproveedor);

    this.EnableItemAndSave();
  }

  EnableItemAndSave() {
    const rutProveedor = this.formHeader.get('rutProveedor').value;

    if (rutProveedor != '' && rutProveedor != null) {
      this.EnableDoc = true;
    } else {
      this.EnableDoc = false;
    }

    if (rutProveedor != '' && rutProveedor != null && this.folio > 0) {
      const tipodte_codigo = 61;

      this.searchByFolio(this.folio, tipodte_codigo, rutProveedor);
    } else {
      if (this.formHeader.get('nFolio').value == '') {
        this.EnableButton = false;
      }

      if (this.formHeader.get('nFolio').value == 0) {
        this.EnableButton = false;
      }

      if (!this.folio && rutProveedor != '' && rutProveedor != null) {
        this.EnableButton = false;
      }

      if (rutProveedor === '') {
        this.EnableButton = false;
        this.proveedorSeleccionado.nombre = null;
      }

      if (rutProveedor === null) {
        this.EnableButton = false;
        this.proveedorSeleccionado = null;
      }
    }
  }

  onProductoNoEncontrado() {
    this.clearProductoSeleccionadoData();
  }

  clearProductoSeleccionadoData() {
    this.productoSeleccionado = null;
  }

  // input Precio
  onChangePrecioU(precio) {
    this.priceU = parseInt(precio);

    if (precio === '') {
      this.priceU = 0;
    }

    var tax = 0;
    if (this.taxInput > 0) {
      tax = this.taxInput;
    }

    var amount = 0;
    if (this.amountInput > 0) {
      amount = this.amountInput;
    }

    var discount = 0;
    if (this.inputDiscount > 0) {
      discount = this.inputDiscount;
    }

    var surchage = 0;
    if (this.inputSurcharge > 0) {
      surchage = this.inputSurcharge;
    }

    this.searchTotalLinea(tax, amount, this.priceU, discount, surchage);
  }

  // input Cantidad
  onChangeAmount(cantidad) {
    if (cantidad === '') {
      this.amountInput = 0;
    } else {
      this.amountInput = parseInt(cantidad);
      if (this.amountInput > 0) {
        this.amountInput = parseInt(cantidad);
      }
    }

    var tax = 0;
    if (this.taxInput > 0) {
      tax = this.taxInput;
    }

    var price = 0;
    if (this.priceU > 0) {
      price = this.priceU;
    }

    var discount = 0;
    if (this.inputDiscount > 0) {
      discount = this.inputDiscount;
    }

    var surchage = 0;
    if (this.inputSurcharge > 0) {
      surchage = this.inputSurcharge;
    }

    this.searchTotalLinea(tax, this.amountInput, price, discount, surchage);
  }

  // input Descuento
  onChangeDiscount(descuento) {
    this.inputDiscount = parseInt(descuento);

    if (descuento === '') {
      this.inputDiscount = 0;
    }

    var tax = 0;
    if (this.taxInput > 0) {
      tax = this.taxInput;
    }

    var price = 0;
    if (this.priceU > 0) {
      price = this.priceU;
    }

    var amount = 0;
    if (this.amountInput > 0) {
      amount = this.amountInput;
    }

    var surchage = 0;
    if (this.inputSurcharge > 0) {
      surchage = this.inputSurcharge;
    }

    this.searchTotalLinea(tax, amount, price, this.inputDiscount, surchage);
  }

  // input Recargo
  onChangeSurcharge(recargo) {
    this.inputSurcharge = parseInt(recargo);

    if (recargo === '') {
      this.inputSurcharge = 0;
    }

    var tax = 0;
    if (this.taxInput > 0) {
      tax = this.taxInput;
    }

    var price = 0;
    if (this.priceU > 0) {
      price = this.priceU;
    }

    var discount = 0;
    if (this.inputDiscount > 0) {
      discount = this.inputDiscount;
    }

    var amount = 0;
    if (this.amountInput > 0) {
      amount = this.amountInput;
    }

    this.searchTotalLinea(tax, amount, price, discount, this.inputSurcharge);
  }

  openModalSeleccionarProveedor() {
    this.modalSeleccionarProveedor.show();
  }

  onProveedorSeleccionado({ data, origen }) {
    this.proveedorSeleccionado = data;
    this.proveedorSeleccionado.rutFormato = this.rutService.AgregarDV(this.proveedorSeleccionado.rut);
    this.formHeader.get('rutProveedor').setValue(this.proveedorSeleccionado.rutFormato);
    this.seleccionaRutProveedor = this.proveedorSeleccionado.rut;

    this.EnableItemAndSave();
    this.onProveedorChange.emit(this.headerData.proveedorSeleccionado);

    //Obtener condicion de pago del proveedor
    const inputCondPago = {
      entidad: {
        cliente_proveedor: {
          empresa_rut: this.rutEmpresa,
          rut: this.proveedorSeleccionado.rut,
        },
      },
    };
  }

  onProveedorNoEncontrado() {
    this.proveedorSeleccionado = null;
    this.EnableButton = false;
    this.clearProveeData();
  }
  clearProveeData() {
    this.clearContent();
    this.onProveedorChange.emit(null);
  }

  clearContent() {
    this.headerData = {};
    this.formValidatorsService.reset(this.formHeader);
  }

  searchTotalLinea(tax, amount, price, discount, surcharge) {
    const inputParams = {
      entidad: {
        tipo_item_codigo: 1, // AFECTO, CAMPO FIJO
        equivalencia_producto_id: this.productoSeleccionado.id,
        producto_proveedor: this.productoSeleccionado.producto_proveedor,
        producto_proveedor_descripcion: this.productoSeleccionado.detalle_producto,
        formato_codigo: this.productoSeleccionado.formato_codigo,
        factor_equivalencia: this.productoSeleccionado.factor_equivalencia,
        producto_codigo: this.productoSeleccionado.producto_codigo,
        sku: this.productoSeleccionado.producto_sku,
        producto_descripcion: this.productoSeleccionado.producto_descripcion,
        formato_codigo_top: this.productoSeleccionado.formato_codigo_top,
        formato_nombre_top: this.productoSeleccionado.formato_descripcion_top,
        cantidad_recibida: amount,
        precio_unitario: price,
        desc_es_porcentaje: this.formItems.get('productoExistente.tipoDesc').value,
        descuento: parseInt(discount),
        rec_es_porcentaje: this.formItems.get('productoExistente.tipoRec').value,
        recargo: parseInt(surcharge),
        es_activo_fijo: this.formItems.get('productoExistente.ActivoFijo').value,
        impuesto_codigo: tax,
      },
    };
    this.currentSearchParams = inputParams.entidad;

    this.documentoRecepcionadoService.obtenerTotalLinea(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.listaDetalleDoc = respuesta;
      this.totalLine = respuesta.total_linea;
      this.detalleNombreItem = respuesta.tipo_item_nombre;
    });
  }

  private validateAllFormFields(formGroup: FormGroup) {
    // {1}
    Object.keys(formGroup.controls).forEach((field) => {
      // {2}
      const control = formGroup.get(field); // {3}
      if (control instanceof FormControl) {
        // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {
        // {5}
        this.validateAllFormFields(control); // {6}
      }
    });
  }

  //TODO: SIN EJECUCION
  AddDetalle() {
    this.validardorInput();
    this.detalleItem = _.cloneDeep(this.currentSearchParams);

    if (this.AddlistaDetalleDocRec.length == 0) {
      this.AddlistaDetalleDocRec = [];
    } else {
      this.AddlistaDetalleDocRec;
    }

    this.validateAllFormFields(this.formItems);

    if (this.formItems.get('productoExistente.codCantidad').value > 0 && this.formItems.get('productoExistente.codPrecioU').value > 0) {
      const inputParams = {
        entidad: {
          rut_receptor: this.rutEmpresa,
          rut_emisor: this.rutService.QuitarDV(this.formHeader.get('rutProveedor').value),
          tipo_dte_codigo: this.formHeader.get('tipoFact').value,
          folio: this.formHeader.get('nFolio').value,
        },
        detalle: {
          tipo_item_codigo: this.detalleItem.tipo_item_codigo,
          tipo_item_nombre: this.detalleNombreItem,
          producto_proveedor: this.formItems.get('productoExistente.codProduct').value,
          producto_proveedor_descripcion: this.detalleItem.producto_proveedor_descripcion,
          formato_codigo: this.detalleItem.formato_codigo,
          factor_equivalencia: this.detalleItem.factor_equivalencia,
          producto_codigo: this.detalleItem.producto_codigo,
          sku: this.detalleItem.sku,
          equivalencia_producto_id: this.detalleItem.equivalencia_producto_id,
          producto_descripcion: this.detalleItem.producto_descripcion,
          formato_codigo_top: this.detalleItem.formato_codigo_top,
          formato_nombre_top: this.detalleItem.formato_nombre_top,
          cantidad_recibida: this.formItems.get('productoExistente.codCantidad').value,
          precio_unitario: this.formItems.get('productoExistente.codPrecioU').value,
          desc_es_porcentaje: this.formItems.get('productoExistente.tipoDesc').value,
          descuento: this.formItems.get('productoExistente.codDescuento').value,
          rec_es_porcentaje: this.formItems.get('productoExistente.tipoRec').value,
          recargo: this.formItems.get('productoExistente.codRecargo').value,
          es_activo_fijo: this.formItems.get('productoExistente.ActivoFijo').value,
          impuesto_codigo: this.detalleItem.impuesto_codigo,
          listaDetalle: this.cleanDetalledocumento(this.AddlistaDetalleDocRec),
        },
        paginaActual: this.paginationContext.CurrentPage,
        cantidadRegistrosPorPagina: 10,
      };
      this.log('inputParams', JSON.stringify(inputParams));

      this.loading = true;

      this.documentoRecepcionadoDetalleService.agregaDetalleProductoRecepcionado(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          this.loading = false;
          return;
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        this.paginationContext.RecordsCount = totalRegistros;
        this.paginationContext.CurrentPage = paginaActual;
        this.paginationContext.PagesCount = totalPaginas;

        const data = registros.map((x) => {
          const params = {
            rut_emisor: x.rut_emisor,
            folio: x.folio,
            tipo_dte_codigo: x.tipo_dte_codigo,
            nro_linea: x.nro_linea,
            producto_codigo: x.producto_codigo,
            formato_codigo: x.formato_codigo,
            formato_nombre: x.formato_nombre,
            producto_descripcion: x.producto_descripcion,
            cantidad_recibida: x.cantidad_recibida,
            precio_neto: x.precio_neto,
            precio_unitario: x.precio_unitario,
            total_linea: x.total_linea,
            equivalencia_producto_id: x.equivalencia_producto_id,
            sku: x.sku,
            es_correcion_monto: x.es_correcion_monto,
            atributos: x.atributos,
          };

          return params;
        });

        this.AddlistaDetalleDocRec = data;
        console.log('VER LOS ELEMENTOS DE DETALLE', this.AddlistaDetalleDocRec);
        this.AddlistaDetalleDocRec.forEach((mov, index) => {
          mov.additionalInfo = {};
          mov.additionalInfo.index = index;
          mov.additionalInfo.checked = false;
        });

        this.totalMonto = _.sumBy(this.AddlistaDetalleDocRec, 'total_linea');
        this.SubTotal = this.totalMonto;
        if (registros.length === 0) {
          this.loading = false;
        }

        this.ClearFiltrosFormItems();
      });
    } else {
      return;
    }
  }

  private cleanDetalledocumento(detalleDocumento, cleanCheck: Boolean = true) {
    // let _detalledocumento = [...detalleDocumento]
    let _detalledocumento = [];
    detalleDocumento.forEach((val) => _detalledocumento.push(Object.assign({}, val)));
    _detalledocumento.map((p) => {
      if (cleanCheck) delete p.__typename;
      delete p.additionalInfo;
    });
    return _detalledocumento;
  }

  checkAllChangeDetalle({ checked }) {
    this.AddlistaDetalleDocRec.forEach((detalle) => {
      detalle.additionalInfo.checked = checked;
    });

    //SELECCIONAR TODO
    this.checkAllDetalle = checked;

    //ELEMENTOS SELECCIONADOS
    this.countSelectDetalle = this.AddlistaDetalleDocRec.filter((x) => x.additionalInfo.checked === true).length;
  }

  checkDetalleList({ index }, { checked }) {
    this.AddlistaDetalleDocRec.map((detalle) => {
      if (detalle.additionalInfo.index === index) {
        detalle.additionalInfo.checked = checked;
      }
    });

    //DESELECCIONAR EL CAMPO SELECT ALL
    const totalUnselected: number = this.AddlistaDetalleDocRec.filter((detalle: any) => !detalle.additionalInfo.checked).length;
    this.checkAllDetalle = totalUnselected === 0;

    //SUMA DE ELEMENTOS SELECCIONADOS
    this.countSelectDetalle = this.AddlistaDetalleDocRec.filter((x) => x.additionalInfo.checked === true).length;
  }

  abrirModalSeleccionDocumento() {
    const proveedorRut = this.formHeader.get('rutProveedor').value;
    this.modalSeleccionarDocumento.load(proveedorRut);
  }

  DeleteDetalle() {
    var atleastOneSelected = this.AddlistaDetalleDocRec.filter((checkbox) => checkbox.additionalInfo.checked === true);

    if (atleastOneSelected.length === 0) {
      this.countSelectDetalle = 0;
      this.toastService.error('No existen registros para eliminar');
      return;
    }

    var UnSelectData = this.AddlistaDetalleDocRec.filter((checkbox) => checkbox.additionalInfo.checked === false);
    this.AddlistaDetalleDocRec = UnSelectData;

    if (this.checkAllDetalle === true) {
      this.countSelectDetalle = 0;
      this.loading = false;
    }

    this.checkAllDetalle = false;
    this.totalMonto = _.sumBy(this.AddlistaDetalleDocRec, 'total_linea');
    this.SubTotal = this.totalMonto;

    this.ClearFiltrosFormItems();
  }

  ClearFiltrosFormItems() {
    //LIMPIAR FILTROS de FORMITEMS
    this.formValidatorsService.reset(this.formItems);
    this.priceU = 0;
    this.amountInput = 0;
    this.inputDiscount = 0;
    this.inputSurcharge = 0;
    this.taxInput = 0;
    this.totalLine = 0;
    this.productoSeleccionado = null;

    this.formItems.get('productoExistente.tipoItems').setValue(4);
    this.formItems.get('productoExistente.codProduct').setValue(null);

    this.optionsFormatoProductoLibre = [{ value: 'UNID', label: 'Unidad' }];
    this.formItems.get('productoLibre.es_exento').setValue(this.PRODUCTO_LIBRE_AFECTO);
    this.formValidatorsService.selectFirstOrDefault(this.formItems.get('productoLibre.formato'), this.optionsFormatoProductoLibre);
    this.detalleItem = null;
  }

  CloseDocRecManualmente() {
    //limpiar Filtros
    const { initDate, currentDate } = this.datesService.GetStartAndCurrentMonth();

    this.formItems.reset(this.formItems);
    this.formValidatorsService.reset(this.formHeader);
    this.formValidatorsService.reset(this.formImpuestos);
    this.formItems.reset(this.formImpuestos);
    this.formMotivoGeneral.reset(this.formImpuestos);

    this.formHeader.get('mesPeriodo').setValue(this.initialValues.mesPeriodo);
    this.formHeader.get('gestion').setValue(this.initialValues.gestion);
    this.formHeader.get('tipoFact').setValue(33);
    this.formHeader.get('FechaDoc').setValue(currentDate);
    this.formHeader.get('MueveInventario').setValue(true);
    this.formHeader.get('bodega').setValue(1);
    this.formHeader.get('doctoReferencia').setValue(33);

    this.formHeader.get('nroDoc').setValue(null);
    this.formHeader.get('rutProveedor').setValue(null);
    this.formHeader.get('nFolio').setValue(null);
    this.formHeader.get('GlosaN').setValue('');
    this.formHeader.get('FechaVenc').setValue(currentDate);
    this.formHeader.get('IvaUsoComun').setValue(false);
    this.formHeader.get('EntregaGratuita').setValue(false);
    this.formHeader.get('MontoBrutoDetalle').setValue(false);
    this.formHeader.get('FactorIva').setValue(0);

    this.formItems.get('productoExistente.tipoItems').setValue(2);
    this.formItems.get('esProductoLibre').setValue(false);

    this.formMotivoGeneral.get('motivo').setValue(0);

    this.folio = null;
    this.SubTotal = 0;
    this.MontoAf = 0;
    this.MontoEx = 0;
    this.DescGbl = 0;
    this.RecargoGbl = 0;
    this.MontoIva = 0;
    this.IvaRec = 0;
    this.IvaNoRec = 0;
    this.IvaActF = 0;
    this.IvaRet = 0;
    this.IvaComn = 0;
    this.TotalBruto = 0;

    this.subTotal = 0;
    this.Descto = 0;
    this.Recargo = 0;
    this.Total = 0;

    this.formItems.get('productoExistente.codProduct').setValue(null);
    this.optionsFormatoProductoLibre = [{ value: 'UNID', label: 'Unidad' }];
    this.formItems.get('productoLibre.es_exento').setValue(this.PRODUCTO_LIBRE_AFECTO);

    this.formItems.get('productoLibre.codigo').setValue(null);
    this.formItems.get('productoLibre.descripcion').setValue(null);
    this.formItems.get('productoLibre.cantidad').setValue(null);
    this.formItems.get('productoLibre.precioUnitario').setValue(null);

    this.impuesto = '';
    this.showBodega = true;
    this.priceU = 0;
    this.amountInput = 0;
    this.inputDiscount = 0;
    this.inputSurcharge = 0;
    this.taxInput = 0;
    this.totalLine = 0;
    this.productoSeleccionado = null;
    this.detalleItem = null;
    this.totalMonto = 0;
    this.proveedorSeleccionado = null;
    this.AddlistaDetalleDocRec = [];
    this.listaDetalleDoc = [];
    this.EnableButton = false;
    this.loading = false;
    this.dataCabecera = null;

    this.detalleCantidad = 0;
    this.additionalHeaderInfo = null;

    this.observaciones = '';
    //  this.modalObservaciones.cleanAll()
    this.modalSeleccionarDocumento.clearLast();

    this.agregarDocModal.hide();
  }

  changeShowImpuesto() {
    if (this.formItems.get('productoExistente.AsigImpuesto').value === true) {
      this.showImpuesto = true;
    } else {
      this.showImpuesto = false;
    }
  }

  saveDocRecManualmente() {
    if (this.TotalBruto === 0) {
      this.toastService.error('Debe ingresar totales');
      return false;
    }
    this.validardorInput();
    if (!this.formHeader.valid) {
      this.toastService.warning('Favor complete los datos requeridos');
      return;
    }
    if (this.dataCabecera != null) {
      this.datoDetalle = this.dataCabecera.detalleDocumento.map((x) => {
        const params = {
          rut_emisor: x.rut_emisor,
          folio: x.folio,
          tipo_dte_codigo: x.tipo_dte_codigo,
          nro_linea: x.nro_linea,
          equivalencia_producto_id: x.equivalencia_producto_id,
          producto_proveedor: x.codigo_producto_proveedor,
          producto_proveedor_descripcion: x.descripcion_producto_proveedor,
          formato_codigo: x.formato_proveedor,
          cantidad_recibida: x.cantidad,
          precio_unitario: x.precio_producto_proveedor,
          total_linea: x.monto_total,
          desc_es_porcentaje: x.es_porcentaje_dscto,
          rec_es_porcentaje: x.es_porcentaje_recargo,
          producto_valido: x.producto_valido,
          producto_codigo: x.producto_codigo,
          formato_codigo_top: x.formato_codigo,
          seleccion: x.additionalInfo.checked,
          cantidad_diferencia: x.additionalInfo.Newcantidad,
        };
        return params;
      });
    }

    const inputParams: any = {
      entidadReferencia: {
        rut_emisor: this.dataCabecera === null ? 0 : this.dataCabecera.cabecera.rut_emisor,
        tipo_dte_codigo: this.dataCabecera === null ? 0 : this.dataCabecera.cabecera.tipo_dte_codigo,
        folio: this.dataCabecera === null ? 0 : this.dataCabecera.cabecera.folio,
      },
      entidad: {
        tipo_ncnd_codigo: this.formItems.get('productoExistente.tipoItems').value,
        rut_receptor: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        mes: this.formHeader.get('mesPeriodo').value,
        anno: this.formHeader.get('gestion').value,
        rut_emisor: this.rutService.QuitarDV(this.formHeader.get('rutProveedor').value),
        tipo_dte_codigo: 61,
        folio: this.formHeader.get('nFolio').value,
        rut_usuario_recepcion: this.rut_usuario, //rut persona registrada
        fecha_recepcion: this.formHeader.get('FechaDoc').value,
        fecha_vencimiento: this.formHeader.get('FechaVenc').value,
        // condicion_pago_codigo: this.formHeader.get('CondPago').value,
        glosa_nominal: this.formHeader.get('GlosaN').value,
        es_entrega_gratuita: this.formHeader.get('EntregaGratuita').value,
        monto_detalle_bruto: this.formHeader.get('MontoBrutoDetalle').value,
        // mueve_inv: false,
        mueve_inv: this.formHeader.get('MueveInventario').value,
        bodega_codigo: this.formHeader.get('bodega').value,
        facto_iva_uso_comun: this.formHeader.get('FactorIva').value,
        monto_imp_adic: this.montoImpuestoAdicional,
        monto_subtotal: this.SubTotal,
        monto_descuento: this.DescGbl,
        monto_recargo: this.RecargoGbl,
        monto_afecto: this.MontoAf,
        monto_exento: this.MontoEx,
        monto_iva: this.MontoIva,
        monto_total: this.TotalBruto,
        iva_recuperable: this.IvaRec,
        iva_no_recuperable: this.IvaNoRec,
        iva_activo_fijo: this.IvaActF,
        iva_retenido: this.IvaRet,
        iva_comun: this.IvaComn,
        motivo_devolucion_codigo: this.formMotivoGeneral.get('motivo').value,
        listaDetalle:
          this.formItems.get('productoExistente.tipoItems').value === 2
            ? this.datoDetalle === null
              ? this.listaVaciaDetalle
              : this.cleanDetalledocumento(this.datoDetalle)
            : this.cleanDetalledocumento(this.AddlistaDetalleDocRec),
      },
    };
    this.log('inputParams', JSON.stringify(inputParams));

    this.documentoRecepcionadoService.guardarNotaCreditoRecepcionado(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }

      console.log('hrettre', respuesta);
      this.toastService.success('Operación realizada con éxito');
      this.CloseDocRecManualmente();
      this.BuscarItems();
    });
  }

  public cleanData() {
    // Form
    this.formHeader.reset();
    this.formHeader.markAsUntouched();
    this.formHeader.markAsPristine();

    this.formHeader.get('doctoReferencia').setValue(33);

    this.setDefaultDoctoReferencia();
  }

  BuscarItems() {
    this.onExecuteBuscar.emit(1);
  }

  private fetchMontoIVA(montoAfecto: number) {
    const inputParams = {
      entidad: {
        rut_receptor: this.rutEmpresa,
        monto_afecto: montoAfecto,
      },
    };

    this.log('fetch monto IVA', JSON.stringify(inputParams));
    this.documentoRecepcionadoService.obtenerMontoImpuesto(inputParams, ({ respuesta }) => {
      const montoIVA = respuesta;
      this.MontoIva = montoIVA;
      this.TotalBruto = this.MontoIva + this.MontoAf + this.MontoEx + this.montoImpuestoAdicional;
    });
  }

  private fetchPrecioCosto(producto) {
    const inputParams = {
      entidad: {
        empresa_rut: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        producto_codigo: producto.producto_codigo,
        formato_codigo: producto.formato_codigo_top,
      },
    };

    this.log('fetch monto IVA', JSON.stringify(inputParams));
    this.listaPrecioDetalleService.obtenerPrecioCosto(inputParams, ({ respuesta }) => {
      const precioCosto = respuesta.precio_costo;
      this.formItems.get('productoExistente.codPrecioU').setValue(precioCosto);
    });
  }

  public AddDetalleSinSKU() {
    this.validardorInput();

    this.formValidatorsService.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      return;
    }

    this.detalleItem = _.cloneDeep(this.currentSearchParams);

    if (this.AddlistaDetalleDocRec.length == 0) {
      this.AddlistaDetalleDocRec = [];
    } else {
      this.AddlistaDetalleDocRec;
    }

    this.log('DETALLE 2', this.formHeader.get('tipoFact').value);
    this.validateAllFormFields(this.formItems);

    if (this.formItems.get('productoLibre.cantidad').value > 0 && this.formItems.get('productoLibre.precioUnitario').value > 0) {
      const { rutProveedor, nFolio } = this.formHeader.value;
      const inputParams = {
        entidad: {
          rut_receptor: this.rutEmpresa,
          rut_emisor: this.rutService.QuitarDV(rutProveedor),
          tipo_dte_codigo: 61,
          folio: nFolio === null ? 0 : nFolio,
        },
        detalle: {
          tipo_item_codigo: this.formItems.get('productoLibre.es_exento').value === this.PRODUCTO_LIBRE_AFECTO ? 1 : 2,
          tipo_item_nombre: this.formItems.get('productoLibre.es_exento').value === this.PRODUCTO_LIBRE_AFECTO ? 'AFECTO' : 'EXENTO',
          producto_proveedor: this.formItems.get('productoLibre.codigo').value === null ? '0' : this.formItems.get('productoLibre.codigo').value,
          producto_proveedor_descripcion: this.formItems.get('productoLibre.descripcion').value,
          formato_codigo: this.formItems.get('productoLibre.formato').value,
          factor_equivalencia: 0,
          producto_codigo: 0,
          sku: '',
          equivalencia_producto_id: 0,
          producto_descripcion: '',
          formato_codigo_top: '',
          formato_nombre_top: '',
          cantidad_recibida: this.formItems.get('productoLibre.cantidad').value,
          precio_unitario: this.formItems.get('productoLibre.precioUnitario').value,
          desc_es_porcentaje: false,
          descuento: 0,
          rec_es_porcentaje: false,
          recargo: 0,
          es_activo_fijo: false,
          impuesto_codigo: 0,
          listaDetalle: this.cleanDetalledocumento(this.AddlistaDetalleDocRec),
        },
        paginaActual: this.paginationContext.CurrentPage,
        cantidadRegistrosPorPagina: 20,
      };
      this.log('inputParams', JSON.stringify(inputParams));

      this.loading = true;

      this.documentoRecepcionadoDetalleService.agregaDetalleProductoSinSKURecepcionado(inputParams, ({ mensajes, respuesta }) => {
        const ok = respuesta !== null;
        if (!ok) {
          this.messageRendererService.showErrors(mensajes);
          this.loading = false;
          return;
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
        this.paginationContext.RecordsCount = totalRegistros;
        this.paginationContext.CurrentPage = paginaActual;
        this.paginationContext.PagesCount = totalPaginas;

        this.AddlistaDetalleDocRec = registros;

        this.AddlistaDetalleDocRec.forEach((mov, index) => {
          mov.additionalInfo = {};
          mov.additionalInfo.index = index;
          mov.additionalInfo.checked = false;
        });
        this.EnableButton = this.AddlistaDetalleDocRec.length > 0;
        this.totalMontosinSKU = _.sumBy(this.AddlistaDetalleDocRec, 'total_linea');
        this.subTotalsinSKU = _.sumBy(this.AddlistaDetalleDocRec, 'precio_unitario');
        this.DesctosinSKU = _.sumBy(this.AddlistaDetalleDocRec, 'descuento');
        this.RecargosinSKU = _.sumBy(this.AddlistaDetalleDocRec, 'recargo');
        this.TotalsinSKU = _.sumBy(this.AddlistaDetalleDocRec, 'total_linea');

        if (registros.length === 0) {
          this.loading = false;
        }

        this.ClearFiltrosFormItems();
      });
    } else {
      return;
    }
  }

  onchangeItem(tipoItem) {
    console.log(tipoItem);
    if (tipoItem.value === 2) {
      this.EnableButton = true;
      this.AddlistaDetalleDocRec = [];
      this.totalMontosinSKU = 0;
      this.subTotalsinSKU = 0;
      this.DesctosinSKU = 0;
      this.RecargosinSKU = 0;
      this.TotalsinSKU = 0;
    } else {
      this.EnableButton = false;
    }
  }

  // showModalObservaciones() {
  //   this.modalObservaciones.show()
  // }

  saveObservaciones({ data: observaciones }) {
    this.observaciones = observaciones;
  }

  checkListaDoc(detalle) {
    this.log('check', JSON.stringify(detalle.additionalInfo.checked));
    const selectedMain: any = this.dataCabecera.detalleDocumento.filter((p) => p.additionalInfo.index === detalle.additionalInfo.index)[0];
    selectedMain.seleccion = !detalle.additionalInfo.checked;
    selectedMain.additionalInfo.checked = !detalle.additionalInfo.checked;
    // if (selectedMain.seleccion === false)
    //   selectedMain.cantidad = 0
  }

  devolucionChange(detalle, newDevolucion) {
    this.detalleCantidad = newDevolucion;

    this.log(JSON.stringify(detalle), newDevolucion);

    const selectedMain: any = this.dataCabecera.detalleDocumento.filter((p) => p.additionalInfo.index === detalle.additionalInfo.index)[0];

    console.log('CABECERA', this.dataCabecera);
    console.log('DETALLE CANTIDAD', this.detalleCantidad);

    const datos = this.dataCabecera.detalleDocumento.map((x: any, index: number) => {
      const params = {
        rut_emisor: x.rut_emisor,
        folio: x.folio,
        tipo_dte_codigo: x.tipo_dte_codigo,
        nro_linea: x.nro_linea,
        equivalencia_producto_id: x.equivalencia_producto_id,
        producto_proveedor: x.codigo_producto_proveedor,
        producto_proveedor_descripcion: x.descripcion_producto_proveedor,
        formato_codigo: x.formato_proveedor,
        cantidad_recibida: x.cantidad,
        precio_unitario: x.precio_producto_proveedor,
        total_linea: x.monto_total,
        desc_es_porcentaje: x.es_porcentaje_dscto,
        rec_es_porcentaje: x.es_porcentaje_recargo,
        producto_valido: x.producto_valido,
        producto_codigo: x.producto_codigo,
        formato_codigo_top: x.formato_codigo,
        seleccion: x.additionalInfo.checked,
        cantidad_diferencia: x.additionalInfo.Newcantidad ? Number(x.additionalInfo.Newcantidad) : 0,
      };
      if (x.additionalInfo.index === selectedMain.additionalInfo.index && x.additionalInfo.checked === true) {
        params.cantidad_diferencia = x.additionalInfo.NewCantidad ? x.additionalInfo.NewCantidad : Number(x.additionalInfo.Newcantidad);
      }
      return params;
    });
    this.dataDetalle = datos;

    const { rutProveedor, tipoFact, nFolio } = this.formHeader.value;
    const inputParams = {
      entidad: {
        rut_receptor: this.rutEmpresa,
        rut_emisor: this.rutService.QuitarDV(rutProveedor),
        tipo_dte_codigo: tipoFact,
        folio: nFolio,
        listaDetalle: this.cleanAndUpdateDetalle(datos),
      },
      paginaActual: 1,
      cantidadRegistrosPorPagina: 10,
    };

    if (selectedMain.cantidad === '') {
      selectedMain.cantidad = 0;
    }

    if (parseInt(newDevolucion) > selectedMain.cantidad) {
      this.toastService.error('Cantidad no válida');
      return;
    }

    this.documentoRecepcionadoDetalleService.UpdateDetalleProductoRecepcionado(inputParams, ({ mensajes, respuesta }) => {
      const ok = mensajes.filter((m) => m.tipo === 'ERROR').length === 0;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        detalle.additionalInfo.Newcantidad = 0;
        return;
      }
      respuesta.registros.forEach((documento) => {
        delete documento.__typename;
      });

      const dataRespone = respuesta.registros.filter((p) => p.cantidad_diferencia > 0);
      this.subTotal = Math.round(_.sumBy(dataRespone, 'subtotal'));
      this.Descto = Math.round(_.sumBy(dataRespone, 'descuento'));
      this.Recargo = Math.round(_.sumBy(dataRespone, 'recargo'));
      this.Total = Math.round(_.sumBy(dataRespone, 'total_linea'));

      this.toastService.success('Registro editado con éxito');
      selectedMain.seleccion = detalle.additionalInfo.checked;
      selectedMain.additionalInfo.checked = detalle.additionalInfo.checked;
    });
  }

  private cleanAndUpdateDetalle(detalleDocumento, cleanCheck: Boolean = true) {
    // let _detalledocumento = [...detalleDocumento]

    let _detalledocumento = [];
    detalleDocumento.forEach((val) => _detalledocumento.push(Object.assign({}, val)));
    _detalledocumento.map((p) => {
      if (cleanCheck) delete p.__typename;
      delete p.additionalInfo;
    });
    return _detalledocumento;
  }

  validardorInput() {
    if (this.formHeader.get('rutProveedor').value === null) {
      this.toastService.warning('Debe ingresar rut de proveedor');
      return false;
    }
    if (this.formHeader.get('nFolio').value === null) {
      this.toastService.warning('Debe ingresar un numero de Folio');
      return false;
    }
  }
}
